import { Component, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';
import { OptionsComponent } from './options/options.component';
import { BrandingComponent } from './branding/branding.component';
import { TitlesComponent } from './titles/titles.component';
import { CustomQuestionComponent } from '../../manage-settings/custom-question/custom-question.component';
import { LmsSettingsComponent } from '../../manage-settings/lms-settings/lms-settings.component';
import { ReportLabelsComponent } from '../../manage-settings/report-labels/report-labels.component';
import { DrawerService } from '../../../core/services/drawer.service';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_IDS } from '../../../core/constants/drawer-ids.constant';
import { ManageOrganizationDrawerParams } from '../manage-organization.interface';
import { OrgManagementMode } from '../manage-organization.enums';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    NzTabsModule,
    NzButtonModule,
    OptionsComponent,
    BrandingComponent,
    TitlesComponent,
    CommonModule,
    CustomQuestionComponent,
    LmsSettingsComponent,
    ReportLabelsComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent implements OnDestroy {
  selectedTabIndex = 0;
  private readonly destroy$ = new Subject<void>();
  @ViewChild(TitlesComponent) titleComponent!: TitlesComponent;
  @ViewChild('extraTemplate') extraTemplate!: TemplateRef<void>;
  orgParams: ManageOrganizationDrawerParams = {
    organizationId: 0,
    mode: OrgManagementMode.VIEW,
    organizationName: '',
  };
  constructor(private readonly drawerService: DrawerService) {
    this.setupDrawerParams();
  }

  private setupDrawerParams(): void {
    this.drawerService
      .getParams<ManageOrganizationDrawerParams>(DRAWER_IDS.MANAGE_ORG)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.orgParams = params;
        }
      });
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  addNewTitle() {
    this.titleComponent.addTitle();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
